var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"man band-card"},[_c('div',{staticClass:"nav"},[_c('Nav',{attrs:{"title":_vm.navTitle,"fixed":false}}),_c('div',{staticClass:"top"})],1),_c('van-form',{attrs:{"validate-first":""},on:{"submit":_vm.submit}},[_c('van-field',{attrs:{"required":"","disabled":"","size":"large","label":"姓名","rules":[
        { 
          required: true, 
        },
      ]},model:{value:(_vm.form.PatientName),callback:function ($$v) {_vm.$set(_vm.form, "PatientName", $$v)},expression:"form.PatientName"}}),_c('van-field',{attrs:{"required":"","disabled":"","size":"large","label":"身份证号码","rules":[
        { 
          required: true, 
        },
      ]},model:{value:(_vm.form.IDCardNo),callback:function ($$v) {_vm.$set(_vm.form, "IDCardNo", $$v)},expression:"form.IDCardNo"}}),_c('van-field',{attrs:{"required":"","size":"large","label":"现住址","placeholder":"请输入现住址","rules":[
        { 
          required: true, 
          message: '请输入地址' ,
        },
      ]},model:{value:(_vm.form.Address),callback:function ($$v) {_vm.$set(_vm.form, "Address", $$v)},expression:"form.Address"}}),_c('van-field',{attrs:{"required":"","size":"large","label":"手机号码","placeholder":"请输入手机号码","rules":[
        {
          required: true,
          message: '手机号码格式不正确',
          validator: _vm.certificatePhone,
        },
      ]},model:{value:(_vm.form.Mobile),callback:function ($$v) {_vm.$set(_vm.form, "Mobile", $$v)},expression:"form.Mobile"}}),_c('van-field',{attrs:{"required":"","disabled":"","size":"large","label":"年纪","rules":[
        { 
          required: true, 
        },
      ]},model:{value:(_vm.form.PatientAge),callback:function ($$v) {_vm.$set(_vm.form, "PatientAge", $$v)},expression:"form.PatientAge"}}),_c('van-field',{attrs:{"required":"","disabled":"","size":"large","label":"性别","rules":[
        { 
          required: true, 
        },
      ]},model:{value:(_vm.form.PatientSex),callback:function ($$v) {_vm.$set(_vm.form, "PatientSex", $$v)},expression:"form.PatientSex"}}),_c('van-field',{attrs:{"required":"","disabled":"","size":"large","label":"生日","rules":[
        { 
          required: true, 
        },
      ]},model:{value:(_vm.form.BirthDay),callback:function ($$v) {_vm.$set(_vm.form, "BirthDay", $$v)},expression:"form.BirthDay"}}),(_vm.ishaveID)?_c('div',{staticClass:"submit"},[_c('van-button',{staticClass:"bottom_button",attrs:{"round":"","block":"","type":"info","native-type":"submit","size":"nomal"}},[_vm._v("建档并绑定")])],1):_vm._e()],1),_c('div',{staticClass:"empty"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }